import React from 'react';
import { observer } from 'mobx-react-lite';

const Mileage = observer(({ mileage, isPurchase }) => {
  if (mileage !== 0 && !mileage) return null;

  return (
    <tr>
      <td className="pale">Пробег</td>
      <td>
        <span className="bold">
          {isPurchase && 'до '}
          {mileage} км
        </span>
      </td>
    </tr>
  );
});

export default Mileage;
